export default {
	HelloWorld: 'HelloWorld fr',
}
